import BaseService from "./base.service";

class ComplexService {
    getcomplexlist() {
            return BaseService.apiGetRequest('getcomplexlist');
    }
}
export default new ComplexService();
